<template>
  <div class="s-breadcrumbs-seo">
    <SBreadcrumbs
      :breadcrumbs
      data-gtm-container="breadcrumbs"
      :tag="NuxtLink"
    />
  </div>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";

import { SBreadcrumbs } from "@solvari/components";

import { useHost } from "~/shared/composables/useHost.ts";
import { useStructuredData } from "~/shared/composables/useMetaData.ts";

const props = defineProps<{
  breadcrumbs: (Record<string, unknown> & { href?: string; label: string })[];
}>();

const host = useHost();

useStructuredData(() => ({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  "@type": "BreadcrumbList",
  itemListElement: props.breadcrumbs.map(({ href, label }, index) => ({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "@type": "ListItem",
    position: index + 1,
    name: label,
    item: href ? `https://${host}${href}` : undefined,
  })),
}));
</script>

<style lang="postcss">
.s-breadcrumbs-seo {
  @apply flex w-full items-center py-4;
}
</style>
